module.exports = __webpack_public_path__ + "img/crop-image.5dd02346.svg";